<template>
  <a-tabs
    v-model="activeKey"
    type="editable-card"
    :hideAdd="true"
    @edit="remove"
    @tabClick="gotorouter"
    @contextmenu.prevent="openMenu($event)"
    style="width: 100%;text-align: left"
  >
    <a-tab-pane
      v-for="pane in $store.state.tags.tagsArr"
      :key="pane.id"
      :tab="pane.name"
      :closable="pane.closable"
    >
    </a-tab-pane>
  </a-tabs>
</template>

<script>
import { setStorage, getStorage } from "@/utils/auth";
export default {
  name: "tagsView",
  props: {
    tagsSelectArr: Array
  },
  data() {
    return {
      activeKey: this.$store.state.tags.tagsArr[0].id,
      newTabIndex: 0,
      top: 0,
      left: 0,
      visible: false
    };
  },
  watch: {
    $route: {
      handler(val, oldVal) {
        if (val) {
          let a = false;
          if (
            this.$store.state.tags.tagsArr.filter(
              items => items.url == val.path
            ).length != 0
          ) {
            a = true;
          }
          if (!a) {
            console.log(a, "嘿嘿");
            setStorage("oldval", oldVal.path);
            let tagsid = null;
            this.$store.state.tags.tagsArr.forEach(item => {
              if (item.url == oldVal.path) {
                tagsid = item.id;
              }
            });
            this.activeKey = tagsid;
          } else {
            let tagsid = null;
            this.$store.state.tags.tagsArr.forEach(item => {
              if (item.url == val.path) {
                tagsid = item.id;
              }
            });
            this.activeKey = tagsid;
          }
        }
      },
      // 深度观察监听
      deep: true
    }
  },
  methods: {
    gotorouter(e) {
      let path = null;
      this.$store.state.tags.tagsArr.filter(item => {
        if (item.id == e) {
          path = item.url;
        }
      });
      if (path && this.$route.path != path) {
        this.$router.push(path);
      } else {
        console.log(999);
      }
    },
    openMenu(e) {
      let x = e.clientX;
      let y = e.clientY;
      this.$emit("tagsRightClick", [x, y, true]);
    },
    remove(targetKey) {
      let activeKey = this.activeKey;
      let lastIndex;
      this.$store.state.tags.tagsArr.forEach((pane, i) => {
        console.log(pane, i);
        if (pane.id === targetKey) {
          lastIndex = i - 1;
        }
      });
      const panes = this.$store.state.tags.tagsArr.filter(
        pane => pane.id !== targetKey
      );
      if (panes.length && activeKey === targetKey) {
        if (lastIndex >= 0) {
          activeKey = panes[lastIndex].id;
          this.$router.push(this.$store.state.tags.tagsArr[lastIndex].url);
        } else {
          activeKey = panes[0].id;
        }
      }
      this.$store.commit("CHANGE_TAGS_ARR", panes);
      this.activeKey = activeKey;
      console.log(this.$store.state.tags.tagsArr, "112233");
    }
  },
  created() {
    // console.log(this.$route.path, "呦呦呦");
    if (
      this.$store.state.tags.tagsArr.filter(
        item => item.url == this.$route.path
      ).length == 0
    ) {
      let old = getStorage("oldval");
      this.$store.state.tags.tagsArr.map(item => {
        if (old == item.url) {
          this.activeKey = item.id;
        }
      });
    } else {
      this.$store.state.tags.tagsArr.map(item => {
        if (this.$route.path == item.url) {
          this.activeKey = item.id;
        }
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.tags-view-container {
  width: 100%;
  height: 54px;
  background: #fff;
  border-bottom: 1px solid #d8dce5;
  box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.12), 0 0 3px 0 rgba(0, 0, 0, 0.04);
}
</style>
